import { Stack } from '@mantine/core';

import { useState } from 'react';

import type { Proposal, RequirementResponse } from '../../../types/apiTypes';
import {
  EditorPaneViewSelector,
  OpportunityDocumentsViewer,
  type ViewSelectorProps
} from '../../../components';

type Props = {
  proposal: Proposal
  requirementResponses: RequirementResponse[]
  focusedRequirementUid: string
  onSelectRequirement?: (reqUid: string) => void
  onAddRequirement?: (requirementText: string, opportunityFileUid?: string) => void
} & ViewSelectorProps;

const DocumentsViewer: React.FC<Props> = (props: Props) => {
  const [currentFileIndex, setCurrentFileIndex] = useState(0);

  return (
    <Stack gap={0}>
      <EditorPaneViewSelector {...props} />
      <OpportunityDocumentsViewer {...props}
        // Special case where we have to use calc because the PDF viewer styling is finicky
        style={{ height: 'calc(100% - 117px)' }}
        onClickFile={(fileIndex) => { setCurrentFileIndex(fileIndex); }}
        currentFileIndex={currentFileIndex}
        onClickHighlightedRequirement={props.onSelectRequirement}
      />
    </Stack>
  );
};

export default DocumentsViewer;
